import React, { useEffect, useState } from 'react'
import { IMG_BASE_URL } from '../../../../config/Config'
import { useNavigate } from 'react-router-dom';
import { get_shop_by_collection } from '../../../../api/global/Global'

const Home_Shop_By_Collection = (homeData) => {
    const navigate = useNavigate();
    const shop_by_collection = homeData?.data?.shop_by_collection
    const [all_Collections, setAllCollections] = useState([])

    const get_Shop_By_Collection = async () => {
        try {
            const response = await get_shop_by_collection()
            if (response?.data?.status == 200) {
                setAllCollections(response?.data?.data?.collection
                )
            } else if (response?.response?.data?.status == 500) {
                console.log(response?.response?.data?.message);

            }

        } catch (error) {

        }
    }
    useEffect(() => {
        get_Shop_By_Collection()
    }, [])

    return (
        <div>
            <section className="gi-deal-section py-[40px] max-[767px]:py-[30px] wow fadeInUp" data-wow-duration="2s">
                <div className="flex flex-wrap justify-between items-center mx-auto min-[1600px]:max-w-[1450px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                    <div className="w-full flex flex-wrap px-[12px]">
                        <div className="gi-deal-section w-full">
                            <div className="gi-products">
                                <div className="gi-tab-title grid grid-cols-1 gap-3 items-center w-full mb-5">
                                    <div className="section-detail text-center">
                                        <h2
                                            className="bodonibook_font text-3xl text-gray-900 font-bold capitalize">
                                            Shop By Collection</h2>
                                        <p className="mt-[5px] text-[14px] font-semibold text-gray-700 capitalize">A Range of Exquisite
                                            Products</p>
                                    </div>
                                </div>
                                <div className="gi-deal-block" data-aos="fade-up" data-aos-duration="2000"
                                    data-aos-delay="300">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-6">
                                        {
                                            all_Collections?.slice(0, 5)?.map((product_list_result) => {
                                                return (
                                                    <>
                                                        <div onClick={() => {

                                                            navigate(`/collection/${product_list_result?.slug}`)

                                                        }}
                                                            className="gi-products bg-no-repeat text-center relative cursor-pointer rounded-lg overflow-hidden shadow-custome my-4"
                                                        >
                                                            <div className='relative'>
                                                                <img src={`${IMG_BASE_URL}${product_list_result?.image}`} className="aspect-[calc(4*3+1)/16] object-cover w-full mx-auto" alt={product_list_result?.image_alt} />
                                                                <div className='p-5 h-full absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end'>
                                                                    <h4 className="text-lg bodonibook_font font-semibold text-white">
                                                                        {product_list_result?.name
                                                                        }
                                                                    </h4>

                                                                    <span className="underline text-white uppercase text-[13px] mt-3 font-bold">Shop Now</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })
                                        }

                                    </div>
                                </div>
                                <div className="text-center"><button onClick={() =>
                                    navigate("/shop-by-collection", {
                                        state: { all_Collections }, // same as state: { all_Collections: all_Collections }
                                    })
                                }
                                    className="mt-2 text-[13px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-3 hover:bg-red-700 hover:text-white">
                                    View All</button></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Home_Shop_By_Collection